import React, { useEffect, useRef, useState } from "react";

import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { MdEdit } from "react-icons/md";
import { IoMdInformationCircle } from "react-icons/io";

import ImageLoading from "../../components/ImageLoading";
import NoSearchitems from "../../components/NoSearchitems";
import AmlCheckModal from "../../components/AmlCheckModal";
import AmlBadge from "../../components/AmlBadge";
import CustomTooltip from "../../components/CustomTooltip";
import all from "../../images/all.png";
import desc from "../../images/desc.png";
import asc from "../../images/asc.png";
import { CgArrowDown, CgArrowUp } from "react-icons/cg";
import { TbFilterX } from "react-icons/tb";

function UserTable({
  setTotalPages,
  setTotalRows,
  pageNo,
  rowsPerPage,
  searchValue,
  setEndIndex,
  status,
  advancedStartDate,
  advancedEndDate,
  filterApplied,
}) {
  const [list, setList] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [amlModalOpen, setAmlModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [render, setRender] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const sortRef = useRef(null);
  const sortDivRef = useRef(null);

  const sortStates = ["", "asc", "desc"];
  const [sortType, setSortType] = useState("");
  const [sortBy, setSortBy] = useState(sortStates[0]);
  const [sortTypeTemp, setSortTypeTemp] = useState("");
  const [openSorting, setOpenSorting] = useState(false);

  const handleClickOutside = (event) => {
    if (sortRef.current && sortRef.current.contains(event.target)) {
      return;
    }
    if (sortDivRef.current && !sortDivRef.current.contains(event.target)) {
      setOpenSorting(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchUsers = async (controller) => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
      signal: controller.signal,
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/lender/v1/users?page=${pageNo}&per_page=${rowsPerPage}&filters=${searchValue}&status=${status}&sort_by=${sortBy}&start_date=${advancedStartDate}&end_date=${advancedEndDate}&filter_by_created_at=${filterApplied}`,
        options
      );
      setTotalPages(res.data.total_page_count);
      setTotalRows(res.data.total_records);
      setList(res.data.user_data);
      setImageLoading(false);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  function truncateText(text, maxLength) {
    if (text === null) return "---";
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }

  useEffect(() => {
    sessionStorage.removeItem("kyc_search");
    const controller = new AbortController();
    fetchUsers(controller);
    return () => {
      controller.abort();
    };
  }, [pageNo, rowsPerPage, searchValue, status, render, sortBy, filterApplied]);
  useEffect(() => {
    setEndIndex(Number(rowsPerPage));
  }, [rowsPerPage]);
  function capitalize(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const handleEdit = (uuid, status, name) => {
    const user = {
      uuid: uuid,
      name: name,
      status: status,
    };
    setSelectedUser(user);

    setAmlModalOpen(true);
  };

  return (
    <div className="pt-3 w-full bg-white ">
      {imageLoading && (
        <div className="w-full h-[calc(100vh-245px)] flex items-center justify-center">
          <ImageLoading />
        </div>
      )}
      {!imageLoading && (
        <table className="w-full box-border h-full flex flex-col">
          <thead className="text-sm font-semibold h-full">
            <tr className="w-full flex items-center relative">
              <th className="text-left pl-6 pr-4 pt-3 pb-2 w-[17%]">
                <div
                  className="flex flex-row items-center gap-1 cursor-pointer"
                  ref={sortRef}
                  onClick={() => {
                    if (sortTypeTemp === "name") {
                      setOpenSorting(!openSorting);
                    } else {
                      setOpenSorting(true);
                      setSortTypeTemp("name");
                      setSortType("name");
                      setSortBy("");
                    }
                  }}
                >
                  Name{" "}
                  {sortType === "name" && sortBy === "name_asc" ? (
                    <img src={asc} alt="unapproved" className="" />
                  ) : sortType === "name" && sortBy === "name_desc" ? (
                    <img src={desc} alt="unapproved" className="" />
                  ) : (
                    <img src={all} alt="unapproved" className="" />
                  )}
                </div>
              </th>
              <th className=" w-[13%] text-right flex items-center justify-center">
                <span> AML Check </span>
                <span className=" ml-1 mt-[2px]">
                  <CustomTooltip>
                    <IoMdInformationCircle size={17} color="#00394d" />
                  </CustomTooltip>
                </span>
              </th>
              <th className="ml-1 w-[3%] text-left "></th>
              <th className="text-right  pt-3 pb-2 w-[10%]">
                <div
                  className="flex flex-row items-center gap-1 cursor-pointer"
                  ref={sortRef}
                  onClick={() => {
                    if (sortTypeTemp === "created") {
                      setOpenSorting(!openSorting);
                    } else {
                      setOpenSorting(true);
                      setSortTypeTemp("created");
                      setSortType("created");
                      setSortBy("");
                    }
                  }}
                >
                  Created On{" "}
                  {sortType === "created" && sortBy === "created_at_asc" ? (
                    <img src={asc} alt="unapproved" className="" />
                  ) : sortType === "created" && sortBy === "created_at_desc" ? (
                    <img src={desc} alt="unapproved" className="" />
                  ) : (
                    <img src={all} alt="unapproved" className="" />
                  )}
                </div>
              </th>
              <th className={`text-right w-[15%]`}>Phone Number</th>

              <th className="text-right w-[13%]">Unique Code</th>
              <th className={`text-left w-[12%] ml-[3%]`}>Distributor</th>
              <th className={`text-right w-[10%]`}>PAN</th>
              <th className={`text-right w-[12%]`}>Aadhar</th>
              <th className={`text-center w-[16%] pl-[3%]`}>KYC Status</th>
              {openSorting && (
                <div
                  className={`w-[162px] px-2 rounded-lg absolute top-8 z-10 bg-white text-xs font-medium shadow-md py-2 ${
                    sortTypeTemp === "name" ? "left-0" : "left-[22%]"
                  }`}
                  ref={sortDivRef}
                >
                  <div
                    className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
                      (sortBy === "name_asc" || sortBy === "created_at_asc") &&
                      "bg-[#A0FF77]"
                    }`}
                    onClick={() => {
                      if (sortType === "name") {
                        setSortBy("name_asc");
                        setOpenSorting(false);
                      } else {
                        setSortBy("created_at_asc");
                        setOpenSorting(false);
                      }
                    }}
                  >
                    <CgArrowUp size={"15px"} /> Sort Ascending
                  </div>
                  <div
                    className={`flex flex-row justify-start items-center gap-3 font-medium text-xs text-[#262626] mt-2 pl-2 py-1 rounded hover:bg-[#E6EBED] cursor-pointer ${
                      (sortBy === "name_desc" ||
                        sortBy === "created_at_desc") &&
                      "bg-[#A0FF77]"
                    }`}
                    onClick={() => {
                      if (sortType === "name") {
                        setSortBy("name_desc");
                        setOpenSorting(false);
                      } else {
                        setSortBy("created_at_desc");
                        setOpenSorting(false);
                      }
                    }}
                  >
                    <CgArrowDown size={"15px"} /> Sort Descending
                  </div>
                  {sortBy && (
                    <div className="flex flex-row justify-center items-center w-full">
                      <button
                        type="button"
                        className="py-[3px] px-2 rounded w-[73px] h-6 font-medium  text-[#00394d] border border-[#00394d] mt-3 flex flex-row justify-center items-center gap-2"
                        onClick={() => {
                          setSortBy("");
                          setSortType("");
                          setSortType("");
                          setOpenSorting(false);
                        }}
                      >
                        <TbFilterX size={"15px"} /> Clear
                      </button>
                    </div>
                  )}
                </div>
              )}
            </tr>
          </thead>

          <tbody
            className={` overflow-auto max-h-[calc(100vh-285px)] ${
              list.length === 0 ? "h-[62.4vh]" : ""
            }`}
          >
            {list.length === 0 && (
              <>
                <NoSearchitems />
              </>
            )}
            {list?.map((data, index) => (
              <tr
                key={index}
                className={`cursor-pointer ${
                  index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                } text-xs font-medium w-full flex items-center hover:bg-[#e6ebed] `}
                onClick={() => {
                  sessionStorage.setItem("kyc_search", searchValue);
                  navigate(`/kyc/${data.id}`);
                }}
              >
                <td
                  className="text-left pl-6 pr-4  w-[17%]"
                  title={
                    data.name != null && data.name.length > 20
                      ? data.name.toLowerCase()
                      : ""
                  }
                >
                  {truncateText(
                    data.name ? capitalize(data.name.toLowerCase()) : "",
                    20
                  ) || "---"}
                </td>
                <td className=" w-[13%]  flex justify-center ">
                  {" "}
                  <AmlBadge status={data.user_status} />
                  {/* <button className=" ml-4 w-[20px] h-[20px] border border-[#dadada] rounded flex justify-center items-center">
                    <MdEdit className="text-[#656565]" size={14} />
                  </button> */}
                </td>
                <td className="ml-1 w-[3%] text-left">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className=" w-[20px] h-[20px] border border-[#dadada] rounded flex justify-center items-center"
                  >
                    <MdEdit
                      className="text-[#656565]"
                      size={14}
                      onClick={() =>
                        handleEdit(data.id, data.user_status, data.name)
                      }
                    />
                  </button>
                </td>
                <td className={`text-right w-[10%] pt-3 pb-2`}>
                  {data.user_created || "---"}
                </td>
                <td className={`text-right w-[15%] pt-3 pb-2`}>
                  {data.phone || "---"}
                </td>
                <td className="text-right  w-[13%]">{data.user_id || "---"}</td>
                <td
                  className={`text-left w-[12%] ml-[3%]`}
                  title={
                    data.partner_name != null && data.partner_name.length > 15
                      ? data.partner_name
                      : ""
                  }
                >
                  {truncateText(data.partner_name, 15) || "---"}
                </td>
                <td className={`text-right w-[10%]`}>
                  {" "}
                  {data.pan_number || "---"}
                </td>
                <td className={`text-right w-[12%]`}>{data.aadhar || "---"}</td>
                <td className={`text-center w-[16%] pl-[3%]`}>
                  <span
                    className={` px-2 py-1  rounded-xl  text-[11px] ${
                      data.kyc_status === "completed"
                        ? "text-[#0ba300] bg-[#dbe8db]"
                        : "bg-[#f8e9e8] text-[#d30d00]"
                    } `}
                  >
                    {data.kyc_status === "incompleted"
                      ? "incomplete"
                      : data.kyc_status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {amlModalOpen && (
        <AmlCheckModal
          setAmlModalOpen={setAmlModalOpen}
          selectedUser={selectedUser}
          setRender={setRender}
        />
      )}
    </div>
  );
}

export default UserTable;
